import {Premium} from 'ApplicationEntry/models/Premium';
import * as P from 'ApplicationEntry/models/Premium';
import {createAction} from 'Shared/utilities/actionCreator';
import {reverseEnum} from 'Shared/utilities/enumUtility';

export enum PremiumActionType {
  CHANGE_WEEKLY = 'premium/CHANGE_WEEKLY',
  CHANGE_BI_WEEKLY = 'premium/CHANGE_BI_WEEKLY',
  CHANGE_28_DAY = 'premium/CHANGE_28_DAY',
  CHANGE_SEMI_MONTHLY = 'premium/CHANGE_SEMI_MONTHLY',
  CHANGE_MONTHLY = 'premium/CHANGE_MONTHLY',
  CHANGE_SEMI_ANNUALLY = 'premium/CHANGE_SEMI_ANNUALLY',
  CHANGE_QUARTERLY = 'premium/CHANGE_QUARTERLY',
  CHANGE_NINTHLY = 'premium/CHANGE_NINTHLY',
  CHANGE_TENTHLY = 'premium/CHANGE_TENTHLY',
  CHANGE_THIRTEENTHLY = 'premium/CHANGE_THIRTEENTHLY',
  CHANGE_ANNUALLY = 'premium/CHANGE_ANNUALLY',
  CHANGE_SECTION_125 = 'premium/CHANGE_SECTION_125',
  CHANGE_BILL_MODE = 'premium/CHANGE_BILL_MODE',
  CHANGE_OVERRIDE_ANNUAL_PREMIUM = 'premium/CHANGE_OVERRIDE_ANNUAL_PREMIUM',
  CHANGE_CWA = 'premium/CHANGE_CWA',
}

export const isPremiumAction = (action: any): action is PremiumAction => action.type in reverseEnum(PremiumActionType);

export const changeWeekly = (weekly: string, productName?: string) =>
  createAction(PremiumActionType.CHANGE_WEEKLY, {weekly, productName});
export const changeBiWeekly = (biWeekly: string) => createAction(PremiumActionType.CHANGE_BI_WEEKLY, {biWeekly});
export const change28Day = (twentyEightDay: string) => createAction(PremiumActionType.CHANGE_28_DAY, {twentyEightDay});
export const changeSemiMonthly = (semiMonthly: string) =>
  createAction(PremiumActionType.CHANGE_SEMI_MONTHLY, {semiMonthly});

export const changeMonthly = (monthly: string, productName?: string) => {
  return createAction(PremiumActionType.CHANGE_MONTHLY, {monthly, productName});
};

export const changeSemiAnnually = (semiAnnually: string) =>
  createAction(PremiumActionType.CHANGE_SEMI_ANNUALLY, {semiAnnually});
export const changeQuarterly = (quarterly: string) => createAction(PremiumActionType.CHANGE_QUARTERLY, {quarterly});
export const changeNinthly = (ninthly: string) => createAction(PremiumActionType.CHANGE_NINTHLY, {ninthly});
export const changeTenthly = (tenthly: string) => createAction(PremiumActionType.CHANGE_TENTHLY, {tenthly});
export const changeThirteenthly = (thirteenthly: string) =>
  createAction(PremiumActionType.CHANGE_THIRTEENTHLY, {thirteenthly});
export const changeAnnually = (annually: string) => createAction(PremiumActionType.CHANGE_ANNUALLY, {annually});
export const changeCWA = (cwa: string) => createAction(PremiumActionType.CHANGE_CWA, {cwa});

export const changeBillMode = (billMode: string) => createAction(PremiumActionType.CHANGE_BILL_MODE, {billMode});
export const changeOverrideAnnualPremium = (overrideAnnualPremium: boolean) =>
  createAction(PremiumActionType.CHANGE_OVERRIDE_ANNUAL_PREMIUM, {overrideAnnualPremium});
export const changeSection125 = (section125: boolean) =>
  createAction(PremiumActionType.CHANGE_SECTION_125, {section125});

export type PremiumAction =
  | ReturnType<typeof changeWeekly>
  | ReturnType<typeof changeBiWeekly>
  | ReturnType<typeof change28Day>
  | ReturnType<typeof changeSemiMonthly>
  | ReturnType<typeof changeMonthly>
  | ReturnType<typeof changeSemiAnnually>
  | ReturnType<typeof changeQuarterly>
  | ReturnType<typeof changeNinthly>
  | ReturnType<typeof changeTenthly>
  | ReturnType<typeof changeThirteenthly>
  | ReturnType<typeof changeAnnually>
  | ReturnType<typeof changeBillMode>
  | ReturnType<typeof changeOverrideAnnualPremium>
  | ReturnType<typeof changeSection125>
  | ReturnType<typeof changeCWA>;

type PremiumState = Premium;

export default (state: PremiumState, action: PremiumAction) => {
  switch (action.type) {
    case PremiumActionType.CHANGE_WEEKLY:
      return P.changeWeekly(action.payload.weekly, action.payload.productName!)(state);
    case PremiumActionType.CHANGE_BI_WEEKLY:
      return P.changeBiWeekly(action.payload.biWeekly)(state);
    case PremiumActionType.CHANGE_28_DAY:
      return P.change28Days(action.payload.twentyEightDay)(state);
    case PremiumActionType.CHANGE_SEMI_MONTHLY:
      return P.changeSemiMonthly(action.payload.semiMonthly)(state);
    case PremiumActionType.CHANGE_MONTHLY:
      return P.changeMonthly(action.payload.monthly, action.payload.productName!)(state);
    case PremiumActionType.CHANGE_SEMI_ANNUALLY:
      return P.changeSemiAnnual(action.payload.semiAnnually)(state);
    case PremiumActionType.CHANGE_NINTHLY:
      return P.changeNinthly(action.payload.ninthly)(state);
    case PremiumActionType.CHANGE_TENTHLY:
      return P.changeTenthly(action.payload.tenthly)(state);
    case PremiumActionType.CHANGE_THIRTEENTHLY:
      return P.changeThirteenly(action.payload.thirteenthly)(state);
    case PremiumActionType.CHANGE_QUARTERLY:
      return P.changeQuarterly(action.payload.quarterly)(state);
    case PremiumActionType.CHANGE_ANNUALLY:
      return P.changeAnnually(action.payload.annually)(state);
    case PremiumActionType.CHANGE_CWA:
      return P.changeCWA(action.payload.cwa)(state);
    case PremiumActionType.CHANGE_SECTION_125:
      return P.changeSection125(action.payload.section125)(state);
    case PremiumActionType.CHANGE_OVERRIDE_ANNUAL_PREMIUM:
      return P.changeOverrideAnnualPremium(action.payload.overrideAnnualPremium)(state);
    case PremiumActionType.CHANGE_BILL_MODE:
      return P.changeBillMode(action.payload.billMode)(state);
    default:
      return state;
  }
};
